import BaseApi from './base';

class ValidacionesDocumentosApi extends BaseApi {
  constructor() {
    super('validaciones/documentos');
  }

  getValidacionesDocumentosCliente(documentos_cliente_id) {
    return this.request.get(`/validaciones/documentos/cliente/${documentos_cliente_id}`);
  }
}

export default new ValidacionesDocumentosApi();
